import React from 'react'
import { Modal, ModalTitle } from 'react-bootstrap'
import { SKIP_DELETE_MODAL_TYPES } from 'src/static/fixtures/flexibleSubscription'
import { i18nTranslate } from 'src/utils'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'

const ScanInfoModal = ({
  infoModalType = '',
  isInfoModalEnabled = false,
  toggleScanInfoModal = () => {},
}) => {
  let title = ''
  let message = ''
  switch (infoModalType) {
    case SKIP_DELETE_MODAL_TYPES.SKIP:
      title = i18nTranslate('subscription.skip', 'Unable to Skip items')
      message = i18nTranslate(
        'subscription.skipDetails',
        'At least one subscription item must ship with one-time items. To skip your subscription item, remove one-time items first.'
      )
      break
    case SKIP_DELETE_MODAL_TYPES.DELETE:
      title = i18nTranslate('subscription.delete', 'Unable to Delete items')
      message = i18nTranslate(
        'subscription.deleteDetails',
        'At least one subscription item must ship with one-time items. To delete your subscription items, remove one-time items first.'
      )
      break
    case SKIP_DELETE_MODAL_TYPES.FREQUENCY_CHANGE:
      title = i18nTranslate(
        'subscription.frequencyChange',
        'Unable to Change Frequency'
      )
      message = i18nTranslate(
        'subscription.changeFrequencyDetails',
        'At least one subscription item must ship with one-time items. Since there are no other subscription items in your current shipment, you cannot change the frequency of this item to a one-time purchase. Please add another subscription item to your shipment before making this change.'
      )
      break
    case SKIP_DELETE_MODAL_TYPES.DATE_CHANGE:
      title = i18nTranslate(
        'subscription.dayChange',
        'Unable to Change Processing Day'
      )
      message = i18nTranslate(
        'subscription.changeDayDetails',
        'At least one subscription item must ship with one-time items. To change processing day of your subscription item, remove one-time items first.'
      )
      break
    default:
      break
  }
  return (
    <Modal
      centered={true}
      show={isInfoModalEnabled}
      className="subscription-dialog"
      dialogClassName="quick-view-dialog"
      onHide={toggleScanInfoModal}>
      <Modal.Header className="border-0" closeButton>
        <ModalTitle className="font-weight-bold d-flex m-0">
          <InformationIcon size="1.5rem" className="mr-2" />
          {title}
        </ModalTitle>
      </Modal.Header>
      <Modal.Body className="subscription-dialog-message">{message}</Modal.Body>
    </Modal>
  )
}

export default ScanInfoModal
